export default {"src":"/fly/_next/static/media/Round_Arrow.edf0d50c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};